import { PersonalBonus } from '@widgets/personal/bonus'
import { PersonalHistory } from '@widgets/personal/history'

// import { PersonalOffers } from "@widgets/personal/offers";
// import { PersonalPromoCodes } from "@widgets/personal/promo-codes";
// import { PersonalCoupons } from "@widgets/personal/сoupons";
import styles from './styles.module.scss'


export default function LoyaltyPage () {
  return (
    <div className={styles.root}>
      <PersonalBonus />
      <PersonalHistory />
      {/* <PersonalOffers /> //временно скрываем */}
      {/* <PersonalPromoCodes /> //временно скрываем */}
      {/* <PersonalCoupons /> //временно скрываем */}
    </div>
  )
}